<template>
  <div class="prize-item box-item" @click="toUrl(`${itemData.web_notice_link}`)">
    <div class="img-wrap">
      <el-image class="img" fit="cover" :src="itemData.img || require('@/assets/images/prize-d.jpg')"></el-image>
    </div>
    <div class="title">{{itemData.title}}</div>
  </div>
</template>

<script>
export default {
  name: "caifengItem",
  props: {
    itemData: {
      type:Object,
      default:()=>{},
    }
  },
  data() {
    return {
      
    };
  },
  mounted() {
    
  },
  methods: {
    toUrl(url){
      window.open(url, '_blank');
    }
  },
};
</script>

<style lang="scss" scoped>
</style>
